var map = {
	"./10xiangcunketang.svg": "46d0",
	"./11gonggongxinxi.svg": "c928",
	"./12jibenxinxi.svg": "e6df",
	"./13youkeduanshezhi.svg": "4aff",
	"./1shujukanban.svg": "6102",
	"./2daibanqingdan.svg": "9960",
	"./3changdiyuyue.svg": "54e5",
	"./4dangjianyinling.svg": "2d84",
	"./5mashangban.svg": "5f7e",
	"./6wannengdianhua.svg": "89c5",
	"./7jifenxitong.svg": "7794",
	"./8xiangcunzhili.svg": "626d",
	"./9meilixiangcun.svg": "c6c4",
	"./a1.svg": "929d",
	"./a10.svg": "ce73",
	"./a11.svg": "6392",
	"./a12.svg": "fd2d",
	"./a13.svg": "cfa3",
	"./a14.svg": "96a5",
	"./a15.svg": "1de9",
	"./a16.svg": "2cee",
	"./a17.svg": "3c65",
	"./a18.svg": "c0ea",
	"./a19.svg": "f9ac",
	"./a2.svg": "822d",
	"./a20.svg": "9226",
	"./a21.svg": "2340",
	"./a22.svg": "a68b",
	"./a23.svg": "dd36",
	"./a24.svg": "0be3",
	"./a25.svg": "95be",
	"./a26.svg": "a2c0",
	"./a27.svg": "ecec",
	"./a28.svg": "4095",
	"./a29.svg": "744c",
	"./a3.svg": "8928",
	"./a30.svg": "3885",
	"./a31.svg": "acb0",
	"./a32.svg": "fb54",
	"./a33.svg": "73f1",
	"./a4.svg": "0f47",
	"./a5.svg": "06a3",
	"./a6.svg": "68ca",
	"./a7.svg": "e014",
	"./a8.svg": "ee56",
	"./a9.svg": "a02b",
	"./audit.svg": "2451",
	"./bx-analyse.svg": "0dbd",
	"./configuration.svg": "7302",
	"./goods.svg": "eb1e",
	"./home.svg": "a1d4",
	"./marketing.svg": "2bac",
	"./order.svg": "559f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";